// Modelos de fluxo prontos pra começar rápido. Cada template gera um grafo
// (nodes+edges) que substitui o canvas. Reversível (undo) e só persiste no Salvar.
import { NODE_META } from './nodeMeta';

const node = (id, kind, x, y, extra = {}) => ({
  id,
  type: 'custom',
  position: { x, y },
  data: {
    kind,
    label: NODE_META[kind]?.label || kind,
    color: NODE_META[kind]?.color,
    ...extra,
  },
});
const edge = (s, t) => ({
  id: `e-${s}-${t}`,
  source: s,
  target: t,
  animated: true,
});

export const FLOW_TEMPLATES = [
  {
    key: 'SIMPLE',
    build: () => ({
      nodes: [
        node('start', 'start', 80, 200),
        node('agent', 'agent', 360, 200),
        node('end', 'end', 640, 200),
      ],
      edges: [edge('start', 'agent'), edge('agent', 'end')],
    }),
  },
  {
    key: 'QUALIFY_SALES',
    build: () => ({
      nodes: [
        node('start', 'start', 80, 200),
        node('qualify', 'agent', 340, 200, {
          label: 'Qualificador',
          instruction:
            'Você qualifica o lead: entenda a necessidade, o orçamento e a urgência. Resuma o que descobriu para a próxima etapa.',
        }),
        node('sales', 'agent', 620, 200, {
          label: 'Vendas',
          instruction:
            'Com base na qualificação recebida, apresente a solução ideal e conduza o cliente para o fechamento.',
        }),
        node('end', 'end', 900, 200),
      ],
      edges: [
        edge('start', 'qualify'),
        edge('qualify', 'sales'),
        edge('sales', 'end'),
      ],
    }),
  },
  {
    key: 'FAQ_ESCALATE',
    build: () => ({
      nodes: [
        node('start', 'start', 80, 200),
        node('agent', 'agent', 360, 200, {
          instruction:
            'Responda às dúvidas do cliente usando a base de conhecimento. Se não souber ou o cliente pedir, escale para um atendente humano.',
        }),
        node('end', 'end', 640, 200),
        node('kb', 'tool_search_kb', 360, 380),
        node('esc', 'tool_escalate', 360, 480),
      ],
      edges: [edge('start', 'agent'), edge('agent', 'end')],
    }),
  },
];
